export const uid = () => {
  return Math.random().toString(36).slice(2);
};
